<script>
import {mapActions, mapState} from 'vuex';
import appConfig from '@src/app.config';
import Layout from '@layouts/main.vue';
import Baccarat from '@components/baccarat/index.vue';
import TaiXiu from '@components/taixiu/index.vue';
import XocDia from '@components/xocdia/index.vue';
import Timer from '@components/common/timer.vue';
import Websocket from '@components/common/websocket.vue';
import HistoryDetail from '@components/common/history/history-detail.vue';
import UnauthorizationDialog from '@components/common/unauthorization-dialog.vue';
import UnbalanceDialog from '@components/common/unbalance-dialog.vue';
import EmptyBettingQueueDialog from '@components/common/emptybettingqueue-dialog.vue';
import MaxbetDialog from '@components/common/maxbet-dialog.vue';
import LoginRegister from '@components/common/login-register.vue';
import { TABLE_GAMES } from '@config/constants.js';

export default {
  page: {
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    // eslint-disable-next-line vue/no-unused-components
    Baccarat,
    // eslint-disable-next-line vue/no-unused-components
    TaiXiu,
    // eslint-disable-next-line vue/no-unused-components
    XocDia,
    Timer,
    HistoryDetail,
    MaxbetDialog,
    UnauthorizationDialog,
    UnbalanceDialog,
    EmptyBettingQueueDialog,
    Websocket,
    LoginRegister,
  },
  data() {
    return {
      isPopoverVisible: false,
      popoverOptions: {
        animation: "scale-fade",
        popoverReference: null,
        placement: "auto",
        offset: "0,0"
      },
      roundData: {
        value: "",
        round: 0,
        score: {},
        createdDate: "",
      },
      isGetRoundWithResult: false,
      windowFocus: 0,
    }
  },
  computed: {
    ...mapState('user', ['authorizationStatus', 'token', 'agentId']),
    ...mapState('init', ['rounds', 'status']),
  },
  watch: {
    authorizationStatus: function(newVal){
      console.log("authorizationStatus has new val", newVal, this.token);
      if(newVal === "ERROR"){
        this.$router.push('/sessionout');
      }

      this.initFavorite();

      if(this.token !== "" && this.rounds !== null && this.isGetRoundWithResult === false){
        this.isGetRoundWithResult = true;
        const data = {
          rounds: this.rounds.filter(x => TABLE_GAMES.includes(x.table.id)),
          token: this.token
        };
        console.log('data', data);
        this.getRoundsWithResult(data);
      }
    },
    rounds: function(newVal){
      if(this.token !== "" && this.rounds !== null && this.isGetRoundWithResult === false){
        this.isGetRoundWithResult = true;
        const data = {
          rounds: this.rounds.filter(x => TABLE_GAMES.includes(x.table.id)),
          token: this.token
        }
        this.getRoundsWithResult(data);
      }
    },
    windowFocus: function(newVal){
      console.log("[home] windowFocus has new val", newVal);
    },
  },
  mounted() {
    this.getHistory();
    this.getRounds();

    const { token, agentid } = this.$router.currentRoute.query;
    this.authorize({ token, agentId: parseInt(agentid) });
    this.$nextTick(() => {
      const data = {
        offsetHeight: document.body.offsetHeight,
        innerHeight: window.innerHeight
      };
      console.log('postMessage', data);
      window.parent.postMessage(data, '*');

      const that = this;
      window.addEventListener("focus", () => {
        // console.log('focus', that.windowFocus);
        that.windowFocus += 1;
      });
    })
  },
  methods: {
    ...mapActions('init', ['getRoundsWithResult', 'getRounds', 'getHistory']),
    ...mapActions('favorite', ['initFavorite']),
    ...mapActions('user', ['authorize']),
    closePopover() {
      // console.log('closePopover')
      this.isPopoverVisible = false
    },
    showdetail(val) {
      // console.log('home - showdetail', val);
      const { ref } = val;
      // console.log('openPopover - index', val);
      this.popoverOptions.popoverReference = ref;
      this.roundData = { ...val, score: JSON.parse(val.score) };
      this.isPopoverVisible = true;
    }
  },
  
}
</script>

<template>
  <Layout>
    <div v-if="status === 0" class="center-page">
      <div class="lds-facebook">
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div>
        Vui lòng chờ tải game
      </div>
    </div>
    <div v-else class="product-list">
      <XocDia :window-focus="windowFocus" @showdetail="showdetail" />
      <TaiXiu :window-focus="windowFocus" @showdetail="showdetail" />
      <Baccarat @showdetail="showdetail" />
    </div>
    <Timer />
    <Websocket />
    <UnauthorizationDialog />
    <UnbalanceDialog />
    <MaxbetDialog />
    <EmptyBettingQueueDialog />
    <LoginRegister />
    <HistoryDetail
      :popover-options="popoverOptions"
      :is-popover-visible="isPopoverVisible"
      :round-data="roundData"
      @closePopover="closePopover"
    />
  </Layout>
</template>
